<template>
    <div class="container page">
        <div class="header">
            <van-nav-bar :title="$t('my.商品列表')" class="nav-bar">
                <template #left>
                    <van-icon name="arrow-left" color="#fff" @click="back()" />
                </template>
            </van-nav-bar>
        </div>
        <div class="content ">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
                :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">

                <!-- <van-list
                      v-model="loading"
                      :finished="finished"
                      :immediate-check="false"
                      :finished-text="$t('video.no_more')"
                      @load="onLoad"
                  > -->
                <div class="shop_list">

                    <div v-for="(items, index) in shopList" :key="index" class="shop_list_item">
                        <van-image fit="contain" class="shop_list_item_img" :src="items.img" />
                        <div class="shop_list_item_txt" style="text-align: left;font-size: 14px;">{{ items.name }}</div>
                        <div class="shop_list_item_txt" v-if="items.desc" style="text-align: left; color: #3882b0;font-weight: bold;font-size: 13px;margin-top: 5px;">{{ items.desc }}</div>
                        <div class="shop_list_point" style="text-align: left;">
                            {{ $t('my.积分') }} : <span>{{ items.point }}</span>

                        </div>
                        <div class="shop_list_point" style="font-size: 12px;text-align: left;">
                            <span style="font-size: 11px;color: #333;">{{ $t('my.数量') }}</span>: <span>{{ items.num
                                }}</span>

                        </div>
                        <div class="shop_list_item_btn" :class="(items.num == 0) ? 'hui' : ''"
                            @click="exchange(items, index)">
                            {{ $t('my.兑换') }}
                        </div>
                    </div>
                </div>

                <!-- </van-list> -->
            </van-pull-refresh>
        </div>
    </div>

</template>

<script>
import { Dialog } from 'vant';
export default {
    data() {
        return {
            isLoading: false,
            shopList: [
            ],
            loading: false,
            finished: false,
            page: 1,
            userInfo: {}
        };
    },
    methods: {
        back() {
            return window.history.back();
        },
        getUserInfo() {
            this.$http({
                method: 'get',
                url: 'user_info'
            }).then(res => {
                if (res.code === 200) {
                    this.userInfo = res.data;
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                }
            })
        },
        exchange(item, index) {
            if (item.num == 0) {
                return false
            }
            if (this.userInfo.point < item.point) {

                Dialog.alert({
                    confirmButtonText: this.$t('my.confirm'),
                    message: `MAAF KOIN EMAS ANDA TIDAK CUKUP CUKUP SILAKAN HUBUNGI CS MASING MASING`,
                }).then(() => {
                });
            } else {

                Dialog.alert({
                    confirmButtonText: this.$t('my.confirm'),
                    showCancelButton: true,
                    cancelButtonText: this.$t('my.cancel'),
                    message: `Apakah Anda ingin tukar【${item.name}】`,
                }).then(() => {
                    // on close
                    this.$http({
                        method: 'get',
                        url: 'doexchange',
                        data: {
                            product_id: item.id
                        }
                    }).then(() => {
                        this.shopList[index].num--;
                        Dialog.alert({
                            confirmButtonText: this.$t('my.confirm'),
                            message: `Anda telah berhasil menukarkan【${item.name}】`,
                        }).then(() => {
                            // on close
                        });
                        // this.page++;
                    })
                });
            }


        },
        getList() {
            this.$http({
                method: 'get',
                url: 'goodslist',
                data: {
                    page: this.page,
                    limit: 1000
                }
            }).then(res => {
                console.log(res.data.data)
                this.shopList = res.data.data
                // this.page++;
            })
        },
        onLoad() {
            // this.getList();
            // let timer = setTimeout(() => {
            //   if (this.refreshing) {
            //     this.shopList = [];
            //     this.refreshing = false;
            //   }
            //   this.loading = false;
            //   if (this.shopList.length === this.count) {
            //     this.finished = true;
            //   }
            //   this.finished && clearTimeout(timer);//清除计时器
            // }, 500);
        },
        onRefresh() {
            setTimeout(() => {
                this.$toast(this.$t("reservation.refresh"));
                this.isLoading = false;
                this.getList();
            }, 500);
        },
    },
    created() {
        this.getUserInfo()
        this.getList();
    }
};
</script>
<style lang='less'>
.van-dialog .van-button__text {

    font-size: 14px !important;
}
</style>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    color: #000000;
    font-size: 35px;
}
::v-deep .van-button__text{
  font-size: 30px;
}

::v-deep .van-loading__text {
    color: #000000;
    font-size: 35px;
}

.container .content {
    height: calc(100% - 20px);
    overflow: auto;
}

.shop_list_point {
    margin: 10px 0;
}

.shop_list_point span {
    margin: 10px;
    color: #a082f0;
    margin-left: 0;
}

.shop_list {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 10px;
    box-sizing: border-box;
}

.shop_list_item {
    width: calc(50% - 40px);
    margin: 20px;
    text-align: center;
    background: #fff;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
}

.shop_list_item_img {
    width: 270px;
    height: 270px;
    border-radius: 20px;
}

.shop_list_item_txt {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    // padding: 20px;
    margin-top: 20px;
}

.shop_list_item_btn {
    background: linear-gradient(90deg, #3882b0, #a8197a, #541349, #541950, #541851);
    border-radius: 20px;
    padding: 20px;
    color: #fff;
    display: inline-block;
    width: 80%;
    margin-top: 20px;
}

.hui {
    background: gray;
}

</style>